import { ProjectGroupVO } from '../../../model/vo/project-group.vo';
import { Observable, Subject } from 'rxjs';
import { Injectable } from '@angular/core';

export interface ProjectSettingsNotification {
  success: boolean,
  group?: ProjectGroupVO,
  isArticleProjectGroup?: boolean
}

@Injectable({ providedIn: 'root' })
export class ProjectSettingsService {

  private projectGroupUpdatedSubject: Subject<ProjectSettingsNotification> = new Subject<ProjectSettingsNotification>();
  public get projectGroupUpdated$(): Observable<ProjectSettingsNotification> {
    return this.projectGroupUpdatedSubject.asObservable();
  }

  public notifyProjectGroupUpdatedSuccess(group: ProjectGroupVO, isArticleProjectGroup: boolean): void {
    const notification: ProjectSettingsNotification = {
      success: true,
      group: group,
      isArticleProjectGroup: isArticleProjectGroup
    };
    this.projectGroupUpdatedSubject.next(notification);
  }

  public notifyProjectGroupUpdatedFailure(): void {
    const notification: ProjectSettingsNotification = {success: false };
    this.projectGroupUpdatedSubject.next(notification);
  }
}
